import React from "react";
import { LogRenderContext } from "../LogRenderer";
import ClearCancelled from "../common/ClearCancel";
import { getTargetGroupDetails } from "../utils";

const TargetGroupClearCancelled = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, id, updatedBy, updatedAt } = getTargetGroupDetails(log);
  return <ClearCancelled name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default TargetGroupClearCancelled;
